// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e0bbee6e","703":"74e3019f"}[chunkId] + ".chunk.js";
};